import React from "react";
import {
  CalendarCheck,
  Clock,
  FileStack,
  LayoutDashboard,
  Users,
  Funnel,
  Building2,
  ClipboardCheck,
  Files,
  Hotel,
  KeyRound,
  Ticket,
  DoorOpen,
  Settings,
  Calculator,
  GitBranch,
  FilePlus2
} from "lucide-react";

import locale from "@bonliva-crm/locale";
import { MenuItem } from "@common/Menu";

export enum MenuPathsEnum {
  ACCOMMODATIONS = "/accommodations",
  ACCOMMODATION_REQUESTS = "/accommodation_requests",
  TRAVEL_REQUESTS = "/travel_requests",
  BOOKING = "/bookings",
  TIMEREPORT_KIT_FLOW = "/timereport_kit_flow",
  KITS = "/kits",
  CONSULTANT = "/consultants",
  CONSULTANT_IMPORT = "/consultant_import",
  PIPELINE = "/pipeline",
  CUSTOMERS = "/customers",
  CUSTOMERS_CONTRACTS = "/customer_contracts",
  DASHBOARD = "/dashboard",
  DOCUMENTS = "/documents",
  FORMS = "/forms",
  CONFIG_EDITOR = "/config_editor/contract_templates",
  WORKFLOW_STATUS = "/workflow_status",
  ERP_WR_DRAFTS = "/demand"
}

export const items: MenuItem[] = [
  {
    env: "production",
    icon: <LayoutDashboard size={24} />,
    label: locale.mainMenu.start,
    path: MenuPathsEnum.DASHBOARD,
    badgeContent: 10,
    children: []
  },
  {
    env: "production",
    subtitle: "Bemanning",
    icon: <Users size={24} />,
    label: locale.mainMenu.consultants,
    path: MenuPathsEnum.CONSULTANT
  },
  {
    env: "production",
    indented: true,
    icon: <Funnel size={24} />,
    label: locale.mainMenu.pipeline,
    path: MenuPathsEnum.PIPELINE
  },
  {
    env: "production",
    icon: <Building2 size={24} />,
    label: locale.mainMenu.customers,
    path: MenuPathsEnum.CUSTOMERS
  },
  {
    env: "production",
    icon: <CalendarCheck size={24} />,
    label: locale.mainMenu.bookings,
    path: MenuPathsEnum.BOOKING
  },
  {
    env: "production",
    icon: <Clock size={24} />,
    label: locale.mainMenu.timereportKitFlow,
    path: MenuPathsEnum.TIMEREPORT_KIT_FLOW
  },
  {
    env: "production",
    icon: <FileStack size={24} />,
    label: locale.mainMenu.kitFlow,
    path: MenuPathsEnum.KITS
  },
  {
    env: "production",
    icon: <ClipboardCheck size={24} />,
    label: locale.mainMenu.contracts,
    path: MenuPathsEnum.CUSTOMERS_CONTRACTS
  },
  {
    env: "production",
    icon: <Files size={24} />,
    label: locale.mainMenu.sharedDocuments,
    path: MenuPathsEnum.DOCUMENTS
  },
  {
    env: "production",
    subtitle: "Resa & Boende",
    icon: <Hotel size={24} />,
    label: locale.mainMenu.accommodations,
    path: MenuPathsEnum.ACCOMMODATIONS
  },
  {
    env: "production",
    icon: <KeyRound size={24} />,
    label: locale.mainMenu.accommodationRequests,
    path: MenuPathsEnum.ACCOMMODATION_REQUESTS
  },
  {
    env: "production",
    icon: <Ticket size={24} />,
    label: locale.mainMenu.travelRequests,
    path: MenuPathsEnum.TRAVEL_REQUESTS
  },
  {
    env: "production",
    subtitle: "Övrigt",
    icon: <DoorOpen size={24} />,
    label: locale.mainMenu.departure,
    path: MenuPathsEnum.FORMS
  },
  {
    env: "production",
    icon: <GitBranch size={24} />,
    label: "Workflow-status",
    path: MenuPathsEnum.WORKFLOW_STATUS
  },
  {
    env: "production",
    icon: <Settings size={24} />,
    label: locale.mainMenu.configurationEditor,
    path: MenuPathsEnum.CONFIG_EDITOR
  },
  {
    env: "production",
    icon: <Calculator size={24} />,
    label: locale.mainMenu.tbCalculator,
    onClick: () => {
      window.open(
        "https://apps.powerapps.com/play/2c5b8464-e3b8-4d50-adfa-28e6cb944efb?source=web",
        "_blank"
      );
    }
  },
  {
    env: "production",
    subtitle: "Behovsflöde",
    icon: <FilePlus2 size={24} />,
    label: "Inkommande behov",
    path: MenuPathsEnum.ERP_WR_DRAFTS
  }
];
